import React from 'react'
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MuiPicker } from '../../MuiPicker'
import CalendarTeacherDropdown from '../CalendarTeacherDropdown/CalendarTeacherDropdown'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { format, isValid, parseISO } from 'date-fns'
import SwitchComponent from '../../assets/SwitchComponent'
import CalendarEventStudentCard from './CalendarEventStudentCard'
import OfferOrEvent from './OfferOrEvent'

function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const CalendarEvent = (props) => {
    const [introLesson, setIntroLesson] = React.useState(props.event.isIntro)
    const [somethingWasChanged, setSomethingWasChanged] = React.useState(false)
    const [initialRecurringStatus, setInitialRecurringStatus] = React.useState(false)

    React.useEffect(() => {
      !props.openEvent && setSomethingWasChanged(false)
      props.event && setInitialRecurringStatus(props.event.recurring.isOn)
      props.event && setIntroLesson(props.event.isIntro)
      console.log(props.event)
    }, [props.openEvent])

    const flipTheSwitch = (e) => {
      setSomethingWasChanged(true)
      setIntroLesson(e)
      props.setEventObjectToEdit((prev) => ({...prev, isIntro: e}))
    }

    const changeRepeatStatus = (value) => {
      setSomethingWasChanged(true)
      value === 'none' ? props.setEventObjectToEdit((prev) => ({...prev, recurring:{isOn: false, frequency: value, interval: 0}})) : props.setEventObjectToEdit((prev) => ({...prev, recurring:{isOn: true, frequency: value, interval: 0}}))
    }
    const changeLessonLength = (value) => {
      setSomethingWasChanged(true)
      props.setEventObjectToEdit((prev) => ({...prev, lessonLength: value}))
    }
    const changePendingStatus = (bool) => {
      setSomethingWasChanged(true)
      props.setOfferStatusChanged(true)
      props.setEventObjectToEdit((prev) => ({...prev, isPendingOffer: bool}))
      !bool && props.setEventObjectToEdit((prev) => ({...prev, lessonLength: 30}))
    }
    const tryToCloseWithoutSaving = () => {
      if(somethingWasChanged) {
        props.setDiscardUnsavedChangesPopup(true)
        props.setDiscardType('existing-event')
      } else {
        props.setEditEventToggle(false)
      }
    }

    const tryToSaveAndClose = () => {
      if(somethingWasChanged) {
        if(props.event.recurring.frequency === 'none' && !initialRecurringStatus) {
          props.closeAndEditSoloEvent()
        } else if (props.event.recurring.frequency !== 'none' && !initialRecurringStatus) {
          props.closeAndEditSoloEvent()
        } else if (props.event.recurring.frequency !== 'none' && initialRecurringStatus){
          props.setChangeFollowingEvents(true)
        } else if (props.event.recurring.frequency === 'none' && initialRecurringStatus) {
          props.setChangeFollowingEvents(true)
        }
      } else {
        props.setEditEventToggle(false)
      }
    }

    const tryToDeleteAndClose = () => {
      if(props.event.recurring.frequency === 'none') {
        props.closeAndDeleteSoloEvent()
      } else {
        props.setDeleteFollowingEvents(true)
      }
    }

    return (
      <Transition.Root show={props.openEvent} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={tryToCloseWithoutSaving}>
          <div className="fixed inset-0" />
          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child as={Fragment} enter="transform transition ease-in-out duration-500 sm:duration-700" enterFrom="translate-x-full" enterTo="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leaveFrom="translate-x-0" leaveTo="translate-x-full">
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                    <form className="flex h-full rounded-2xl overflow-hidden flex-col divide-y divide-gray-200 bg-white shadow-2xl">
                      <div className="h-0 flex-1 overflow-y-auto">
                        <div className={classNames(props.event.isPendingOffer ? 'bg-purple-700' : 'bg-blue-700', "py-6 px-4 sm:px-6")}>
                          <div className="flex items-center justify-between">
                            <Dialog.Title className="text-lg m-0 font-medium text-white"><input placeholder="New Event" value={props.event.name} onChange={(e) => props.setEventObjectToEdit({...props.event, name: e.target.value})} className={classNames(props.event.isPendingOffer ? 'bg-purple-700' : 'bg-blue-700', "text-xl m-0 font-medium text-white border-none placeholder:text-white focus:ring-0 focus:outline-none")} /></Dialog.Title>
                            <div className="ml-3 flex h-7 items-center">
                              <button
                                type="button"
                                className={classNames(props.event.isPendingOffer ? 'bg-purple-700' : 'bg-blue-700', "rounded-md text-white border-none hover:text-white focus:outline-none focus:ring-0")}
                                onClick={() => tryToCloseWithoutSaving()}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-1 flex-col justify-between">
                          <div className="divide-y divide-gray-200 px-4 sm:px-6">
                            <div className='text-right mt-2'>
                              <OfferOrEvent isPendingOffer={props.event.isPendingOffer} changePendingStatus={changePendingStatus} />
                            </div>
                          <div className="space-y-6 pt-1 pb-5">
                          <CalendarTeacherDropdown teachers={props.teachers} newEvent={props.event} setNewEvent={props.setEventObjectToEdit} setSomethingWasChanged={setSomethingWasChanged} />
                          <CalendarEventStudentCard event={props.event} setFamilySearchOpen={props.setFamilySearchOpen} setSomethingWasChanged={setSomethingWasChanged} setEventObjectToEdit={props.setEventObjectToEdit}/>
                          <div className='text-left'>
                            {!props.event.isPendingOffer ? <div className='text-sm text-gray-500'>Lesson Length:</div> : <div className='text-sm text-gray-500'>Offer Length:</div>}
                            {!props.event.isPendingOffer 
                              ?
                            <select className='w-full p-2 rounded-md border-gray-300 ' onChange={(e) => changeLessonLength(e.target.value)} value={props.event.lessonLength}>
                              <option value={15}>15 minutes</option>
                              <option value={30}>30 minutes</option>
                              <option value={45}>45 minutes</option>
                              <option value={60}>60 minutes</option>
                            </select>
                            :
                            <select className='w-full p-2 rounded-md border-gray-300 ' onChange={(e) => changeLessonLength(e.target.value)} value={props.event.lessonLength}>
                                  <option value={30}>30 minutes</option>
                                  <option value={60}>1 hour</option>
                                  <option value={90}>1.5 hours</option>
                                  <option value={120}>2 hours</option>
                                  <option value={150}>2.5 hours</option>
                                  <option value={180}>3 hours</option>
                                  <option value={210}>3.5 hours</option>
                                  <option value={240}>4 hours</option>
                            </select>
                            }
                          </div>
                          <div className='inline-block mt-5'>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <MuiPicker setNewEvent={props.setEventObjectToEdit} newEvent={props.event} setSomethingWasChanged={setSomethingWasChanged} />
                            </LocalizationProvider>
                          </div>
                          <div className='text-center inline-block m-10 align-top'>
                            <SwitchComponent enabled={introLesson} setEnabled={flipTheSwitch} />
                            <div className='text-xs'>Intro Lesson</div>
                          </div>
                          {props.event.dateTime !== null && isValid(new Date(props.event.dateTime)) && !props.event.isPendingOffer &&
                            <div>
                              <div className='text-sm text-gray-500'>Repeats:</div>
                              <select value={props.event.recurring.frequency} className='text-sm p-2 border-gray-300 rounded-md w-full' onChange={(e) => changeRepeatStatus(e.target.value)}>
                                <option value="none">Does not Repeat</option>
                                <option value="weekly">Weekly on {new Date(props.event.dateTime) && format(new Date(props.event.dateTime), 'EEEE')}</option>
                                <option value="every-other-week">Every Other {new Date(props.event.dateTime) && format(new Date(props.event.dateTime), 'EEEE')}</option>
                              </select>
                            </div>
                          }
                          <div className="mt-4 flex text-xs">
                            <div className="ml-2 text-gray-400">Created by {props.event.createdBy}</div>
                          </div>
                        </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-shrink-0 justify-end px-4 py-4">
                        <button
                          type="button"
                          className="rounded-md border border-red-500 py-2 px-4 mr-48 text-sm font-medium cursor-pointer text-red-500 bg-white shadow-sm hover:bg-red-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                          onClick={() => tryToDeleteAndClose()}
                        >Delete</button>
                        <button
                          type="button"
                          className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 cursor-pointer"
                          onClick={() => tryToCloseWithoutSaving()}
                        >Cancel</button>
                        <div
                          type="submit"
                          onClick={() => tryToSaveAndClose()}
                          className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 cursor-pointer"
                        >Save</div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    )
}
export default CalendarEvent;